import action from '../commons/slotActionStatus';

export const getSlotsRequestAction = (date, pageNo = 1) => {
    return {
        type: action.GET_SLOTS_REQUEST,
        status: 'GET_SLOTS_REQUEST',
        payload: {
            date,
            pageNo,
        },
        requestState: true,
    };
};

export const getSlotsSuccessAction = ({ data, hasNext, pageNo }) => {
    return {
        type: action.GET_SLOTS_SUCCESS,
        status: 'Slots retrieved sucessfully',
        payload: {
            data,
            hasNext,
            pageNo,
        },
        requestState: false,
    };
};

export const getSlotsFailureAction = (error) => {
    return {
        type: action.GET_SLOTS_FAILURE,
        status: 'Get Slots failure',
        error,
        requestState: false,
    };
};

export const getSlotsAfterSomeTimeRequestAction = (date) => {
    return {
        type: action.GET_SLOTS_SILENTLY_REQUEST,
        status: 'GET_SLOTS_SILENTLY_REQUEST',
        payload: {
            date,
        },
        requestState: true,
    };
};

export const getSlotsAfterSomeTimeSuccessAction = (result) => {
    return {
        type: action.GET_SLOTS_SILENTLY_SUCCESS,
        status: 'Slots retrieved silently sucessfully',
        result,
        requestState: false,
    };
};

export const getSlotsAfterSomeTimeFailureAction = (error) => {
    return {
        type: action.GET_SLOTS_SILENTLY_FAILURE,
        status: 'Get Slots silently failure',
        error,
        requestState: false,
    };
};

export const getDoctorSlotsRequestAction = (date, hospitalId) => {
    return {
        type: action.GET_DATE_SLOTS_REQUEST,
        status: 'GET_DATE_SLOTS_REQUEST',
        payload: {
            date,
            hospitalId,
        },
        requestState: true,
    };
};

export const getDoctorSlotsSuccessAction = (result) => {
    return {
        type: action.GET_DATE_SLOTS_SUCCESS,
        status: 'Date wise Slots retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getDoctorSlotsFailureAction = (error) => {
    return {
        type: action.GET_DATE_SLOTS_FAILURE,
        status: 'Get date wise Slots failure',
        error,
        requestState: false,
    };
};

export const resetSlotsAction = () => {
    return {
        type: action.RESET_SLOTS_STATE
    };
};
